import React, { Children } from 'react';
import { css } from '@linaria/core';
import { brand, theme } from '@terveystalo/design-system-theme';
import { classnames } from '../../utils';
const styles = css `
  padding-left: 2.25rem; /* a custom space to align the texts with those of BulletList */
  list-style: decimal;
`;
const childStyles = css `
  font-family: ${brand.list.font.item.family};
  font-weight: ${brand.list.font.item.weight};
  font-size: ${brand.list.font.item.size};
  line-height: ${brand.list.font.item.lineHeight};
  letter-spacing: ${brand.list.font.item.letterSpacing};
  padding-left: ${theme.spacing['0_25']}; /* make the total space after the dot look like 0.5rem */
  margin: ${theme.spacing['0_5']} 0;

  &::marker {
    font-family: ${brand.list.font.marker.family};
    font-weight: ${brand.list.font.marker.weight};
    letter-spacing: ${brand.list.font.marker.letterSpacing};
    color: ${brand.list.color.default.marker.content};
  }
`;
/**
 * Component which extends the native ol element for displaying a static numbered list.
 *
 * All child elements are wrapped in 'li' elements.
 */
export const NumberedList = ({ children, className, ...rest }) => {
    return (React.createElement("ol", { className: classnames(styles, className), ...rest }, Children.toArray(children).map((child, i) => (React.createElement("li", { key: `num-${i}-${child}`, className: childStyles }, child)))));
};


import "../../../css/atoms/Typography/NumberedList.css";
